import { Route } from 'react-router-dom';
import { TermsOfUsePage } from '../components/legal/TermsOfUsePage';
import { PrivacyPolicyPage } from '../components/legal/PrivacyPolicyPage';
import { FAQ } from '../components/support/FAQ';

export const legalRoutes = (
  <>
    <Route path="/terms" element={<TermsOfUsePage />} />
    <Route path="/privacy" element={<PrivacyPolicyPage />} />
    <Route path="/faq" element={<FAQ />} />
  </>
);